module.exports = __webpack_public_path__ + "static/media/SF_nn_sekundaerlogo_postale_troms_og_finnmark_neg.de7a9152.pdf";